export function flattenObject(obj: Record<string, any>) {
  const flattened = {};

  for (const key in obj) {
    const value = obj[key];

    const regex = /\.$/;

    if (typeof value === "object") {
      const flattenedValue = flattenObject(value);

      for (const subKey in flattenedValue) {
        flattened[`${key}.${subKey}`.replace(regex, "")] =
          flattenedValue[subKey];
      }
    } else {
      flattened[key.replace(regex, "")] = Number.isNaN(+value) ? value : +value;
    }
  }

  return flattened;
}
